import { render } from "./ScoreEntry.vue?vue&type=template&id=5741f9e4&scoped=true"
import script from "./ScoreEntry.vue?vue&type=script&lang=js"
export * from "./ScoreEntry.vue?vue&type=script&lang=js"

import "./ScoreEntry.vue?vue&type=style&index=0&id=5741f9e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5741f9e4"]])

export default __exports__